import type { SaveStatus } from "../api/draftAutosave.js";
import "./styles.css";

export const SAVE_FAILED_COPY = "Not saved. Check your connection";
export const SAVE_LATER_LABEL = "Save and finish later";
export const SAVED_LATER_COPY = "Saved. Come back to this link any time to carry on.";

export function formatClock(ms: number): string {
  const at = new Date(ms);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(at.getHours())}:${pad(at.getMinutes())}`;
}

/** The word and, for a save, the clock time — the time sits in its own span so a phone can drop it. */
function statusCopy(status: SaveStatus | null, now: number): { word: string; time?: string } {
  void now;
  if (status === null) return { word: "" };
  switch (status.kind) {
    case "saving": return { word: "Saving" };
    case "saved": return { word: "Saved", time: formatClock(status.at) };
    case "failed": return { word: SAVE_FAILED_COPY };
  }
}

export interface SaveStatusProps {
  status: SaveStatus | null;
  now?: number;
}

/** KYC-design — a dot and a word: green saved, amber saving, red failed. Never a brand colour. */
export function SaveStatusLine({ status, now = Date.now() }: SaveStatusProps) {
  const copy = statusCopy(status, now);
  const cls = status?.kind === "failed" ? " save-status-failed" : status?.kind === "saving" ? " save-status-saving" : "";
  return (
    <p className={`save-status save-progress-status${cls}`} role="status" aria-live="polite">
      {status && <span className="save-status-dot" aria-hidden="true" />}
      {copy.word}
      {copy.time && <span className="save-status-time">{` ${copy.time}`}</span>}
    </p>
  );
}

export interface SaveLaterProps {
  onSave: () => void;
  disabled: boolean;
}

export function SaveLater({ onSave, disabled }: SaveLaterProps) {
  return (
    <button type="button" className="save-later" onClick={onSave} disabled={disabled}>
      {SAVE_LATER_LABEL}
    </button>
  );
}
